import {
  ASSET_PORTFOLIO_COMPONENT_CONDITION_TYPE,
  AssetPortfolio,
  AssetPortfolioCardData,
  AssetPortfolioComponent,
} from '../type/AssetPortfolio.type';
import {
  AssetItem,
  AssetReport,
  LiabilityItem,
  REPORT_ITEM_TYPE,
  ReportItem,
} from '../../assetReport/type/AssetReport.type';

export const getAssetPortfolioComponentItemList = (
  component: AssetPortfolioComponent,
  reportItemList?: ReportItem[],
) => {
  if (component.conditionList.length === 0 || !reportItemList) return [];

  return reportItemList.filter((reportItem) => {
    if (reportItem.excludeYn) return false;

    const excludeYn = component.conditionList
      .filter((condition) => !condition.includeYn)
      .some((condition) => {
        const ownerYn = !condition.ownerTypeCondition || reportItem.owner === condition.ownerTypeCondition;
        const nameYn = !condition.nameCondition || reportItem.name.includes(condition.nameCondition);
        let typeYn = !condition.reportItemTypeCondition || reportItem.type === condition.reportItemTypeCondition;
        if (typeYn) {
          if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET) {
            typeYn =
              !condition.assetTypeCondition || (reportItem as AssetItem).assetType === condition.assetTypeCondition;
          } else if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.LIABILITY) {
            typeYn =
              !condition.liabilityTypeCondition ||
              (reportItem as LiabilityItem).liabilityType === condition.liabilityTypeCondition;
          }
        }
        return ownerYn && nameYn && typeYn;
      });

    const includeYn = component.conditionList
      .filter((condition) => condition.includeYn)
      .some((condition) => {
        const ownerYn = !condition.ownerTypeCondition || reportItem.owner === condition.ownerTypeCondition;
        const nameYn = !condition.nameCondition || reportItem.name.includes(condition.nameCondition);
        let typeYn = !condition.reportItemTypeCondition || reportItem.type === condition.reportItemTypeCondition;
        if (typeYn) {
          if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET) {
            typeYn =
              !condition.assetTypeCondition || (reportItem as AssetItem).assetType === condition.assetTypeCondition;
          } else if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.LIABILITY) {
            typeYn =
              !condition.liabilityTypeCondition ||
              (reportItem as LiabilityItem).liabilityType === condition.liabilityTypeCondition;
          }
        }
        return ownerYn && nameYn && typeYn;
      });

    return !excludeYn && includeYn;
  });
};

export const getAssetPortfolioComponentListExcludedItemList = (
  componentList: AssetPortfolioComponent[],
  reportItemList?: ReportItem[],
) => {
  if (!reportItemList) return [];

  return reportItemList.filter((reportItem) => {
    if (reportItem.excludeYn) return false;

    const anyIncludeYn = componentList.some((component) => {
      const excludeYn = component.conditionList
        .filter((condition) => !condition.includeYn)
        .some((condition) => {
          const ownerYn = reportItem.owner === condition.ownerTypeCondition;
          let conditionYn = false;
          if (condition.type === ASSET_PORTFOLIO_COMPONENT_CONDITION_TYPE.NAME) {
            conditionYn = reportItem.name.includes(condition.nameCondition);
          } else if (condition.type === ASSET_PORTFOLIO_COMPONENT_CONDITION_TYPE.TYPE) {
            if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET) {
              conditionYn =
                reportItem.type === REPORT_ITEM_TYPE.ASSET &&
                (reportItem as AssetItem).assetType === condition.assetTypeCondition;
            } else if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.LIABILITY) {
              conditionYn =
                reportItem.type === REPORT_ITEM_TYPE.LIABILITY &&
                (reportItem as LiabilityItem).liabilityType === condition.liabilityTypeCondition;
            }
          }
          return ownerYn && conditionYn;
        });

      const includeYn = component.conditionList
        .filter((condition) => condition.includeYn)
        .some((condition) => {
          const ownerYn = reportItem.owner === condition.ownerTypeCondition;
          let conditionYn = false;
          if (condition.type === ASSET_PORTFOLIO_COMPONENT_CONDITION_TYPE.NAME) {
            conditionYn = reportItem.name.includes(condition.nameCondition);
          } else if (condition.type === ASSET_PORTFOLIO_COMPONENT_CONDITION_TYPE.TYPE) {
            if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.ASSET) {
              conditionYn =
                reportItem.type === REPORT_ITEM_TYPE.ASSET &&
                (reportItem as AssetItem).assetType === condition.assetTypeCondition;
            } else if (condition.reportItemTypeCondition === REPORT_ITEM_TYPE.LIABILITY) {
              conditionYn =
                reportItem.type === REPORT_ITEM_TYPE.LIABILITY &&
                (reportItem as LiabilityItem).liabilityType === condition.liabilityTypeCondition;
            }
          }
          return ownerYn && conditionYn;
        });

      return !excludeYn && includeYn;
    });

    return !anyIncludeYn;
  });
};

export const getAssetPortfolioCardData = (assetPortfolio: AssetPortfolio, assetReport?: AssetReport) => {
  const result = assetPortfolio.componentList.map((component) => {
    const targetReportItemList = getAssetPortfolioComponentItemList(component, assetReport?.reportItemList);

    return {
      ...component,
      value: targetReportItemList.reduce((prev, cur) => prev + cur.amount, 0),
      actualRate: 0,
      itemList: targetReportItemList,
    };
  });

  return {
    assetPortfolio: assetPortfolio,
    assetPortfolioComponentDataList: result.map((item) => ({
      ...item,
      actualRate: (item.value / result.reduce((prev, cur) => prev + cur.value, 0)) * 100,
      targetValue: (result.reduce((prev, cur) => prev + cur.value, 0) * item.targetRate) / 100,
    })),
  } as AssetPortfolioCardData;
};
